import {
  ApiBlobGetRequest,
  ApiGetRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Daftar Hutang',
    title_detail: 'Perincian Hutang Usaha',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Daftar Hutang',
        href: '/adm/fin/pembelian/hutang-usaha',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_supplier',
    sortDesc: true,
    fields: [
      {
        key: 'company',
        label: 'Supplier',
      },
      {
        key: 'currency',
        label: 'Mata Uang',
      },
      {
        key: 'total_hutang',
        label: 'Total Hutang',
      },
      {
        key: 'total_pembayaran',
        label: 'Hutang Terbayar',
      },
      {
        key: 'saldo_hutang',
        label: 'Saldo Hutang',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_detail: [
      {
        key: 'tgl_invoice',
        label: 'Tanggal',
      },
      {
        key: 'code_invoice',
        label: 'No Invoice',
      },
      {
        key: 'hari30',
        label: '0-30 Hari',
      },
      {
        key: 'hari60',
        label: '30-60 Hari',
      },
      {
        key: 'hari90',
        label: '60-90 Hari',
      },
      {
        key: 'hariup90',
        label: '> 90 Hari',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    id_supplier: false,
    form: {},
    detail_payment: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeHutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListHutang({ commit, state }, payload = null) {
    commit('changeHutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/hutang`, params);
      commit('changeHutang', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_hutang.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/hutang`, params);
      commit('changeHutang', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailHutang({ commit, state }) {
    commit('changeHutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/hutang/${data.id_supplier}`, params);
    commit('changeHutang', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getPembayaranHutang({ commit, state }, payload = null) {
    commit('changeHutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `fin/hutang/payment/${data.id_supplier}/${payload.invoice_id || ''}`,
      {
        payment_type: payload.payment_type,
      }
    );
    commit('changeHutang', {
      detail_payment: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },
};
